export const integration = {
  menu: {
    title: 'API Integration',
    v1: 'Integration v1 (deprecated)',
    v2: 'Integration v2'
  },
  breadcrumb: {
    title: 'Publisher API Integration',
    api: 'API',
    general: 'Overview',
    user: 'User',
    sms: 'Send messages',
    'get-state': 'Get mailing status',
    database: 'Database',
    'group-database': 'Database groups',
    statistic: 'Statistics',
    phones: 'Phone numbers'
  },
  api: {
    answer_example: 'Response example:',
    api_integration: 'Publisher API Integration',
    api_requests:
      'All API requests require an access token. You can get it using the <b>auth/login</b> request',
    authorization: 'Login',
    because_recipient_hard:
      'because it’s difficult for this recipient to set the message text using',
    combined_sending: 'Combined shipping',
    create_db: 'Create database',
    create_group: 'Сreate group',
    databases: 'Database',
    example: 'Example:',
    get_all_databases: 'Get all databases',
    get_all_groups: 'Get all groups',
    get_mailing_list: 'Get mailing list',
    get_mailing_state: 'Get mailing status',
    get_message_state: 'Get message status',
    group_db: 'Database groups',
    import: 'Import Recipients',
    limit_recipients:
      'This request will send “hello” to all recipients in the list. <b>The maximum number of recipients in a single request is 1000</b>',
    list_macros: 'List of possible macros in the mailing list',
    macros_replace_recipient:
      'Macros used to replace part of a message with dynamic data associated with the recipient.',
    mailing: 'Newsletter',
    not_specify_name_field: 'because it is not specified name field',
    on_phone_number: 'to phone number',
    optional_element_custom_message:
      'You can use the optional custom_message element to hard-code the message text for a specific recipient.',
    overview: 'Overview',
    phones: 'Phone numbers',
    phones_unoccupied: 'Free phone numbers',
    recipients_macros: 'Sending a message to multiple recipients using macros',
    request_header:
      'In response, you will receive a token, which should be indicated in the header of another request.',
    request_send_messages: 'This request will send a message',
    send_message_limit: 'Limit on the number of requests per minute:',
    send_messages: 'Send messages',
    send_messages_group: 'Sending a message to multiple recipients',
    send_single_messages: 'Sending a message to one recipient',
    stat_mailing: 'Newsletter Statistics',
    stat_sms: 'SMS statistics',
    stat_voice: 'Call Statistics',
    statistics: 'Statistics',
    user: 'User',
    user_info: 'User information',
    what_api: 'What is the ZORRA API?',
    zorra_api_text:
      'ZORRA API is a simple method of using some of the functions of our service with your own applications. You can use the API to send messages, receive distribution states, etc.'
  },

  v2: {
    breadcrumb: {
      title: 'API Integration',
      api: 'API',
      general: 'Overview',
      token: 'Token Refresh',
      user: 'User Information',
      sms: 'SMS Mailings',
      verification: 'Number Verification',
      databases: 'Databases',
      hlr: 'HLR Requests'
    },

    1: 'All API requests require an access token. You can get it using the auth/login request',
    2: "The remember parameter is responsible for the lifetime of the token you will receive in response. With 'remember': false - token lifetime is 1 hour, with 'remember': true - 30 days and 10 hours. The parameter is not required when requested and will default to false.",
    3: 'The expires_in parameter reports the token lifetime in seconds.',
    4: 'Updates the token',
    5: 'After receiving the first token, you can refresh it using the refresh method. You can only do this if you have a token with an unexpired lifetime. It will be destroyed, and in return you will receive a new one with a lifetime of 10 hours.',
    6: 'This method allows you to get information about your account. You need to pass the token obtained via the auth/login method in the header.',
    7: 'SMS distribution',
    8: 'Please note that you can only make mailings after you have submitted at least one sender name for moderation and it has been approved.',
    9: 'Send a message to a single recipient',
    10: "This request will send a message from body ('hello') to a phone number from recipient on the date and time specified in start_at.",
    11: 'registered sender in Zorra; required parameter, text field',
    12: 'mailing name; optional parameter; if not specified, the name is generated automatically indicating the date, time, text field',
    13: 'message in the newsletter; required parameter text field',
    14: 'recipient; required parameter',
    15: 'optional text field; used to specify the date the pending mailing was sent. The format is yyyyy-mm-dd hh:mm:ss',
    16: 'Send a message to multiple recipients',
    17: 'This query will send "Hello" to all recipients in database list id = 3759 and record numbers in it from 1 to 10 + per number from',
    18: 'The method is similar to sending to a single recipient, differs by field',
    19: 'array of json objects with bases and range to specify specific recipients, optional parameter',
    20: 'database id to include in the mailing',
    21: 'specify the range of numbers to be included in the mailing',
    22: 'first base number included in the mailing',
    23: 'last base number included in the mailing',
    24: 'For example, there is a base with 3 recipients:',
    25: 'In order to text Michael and Andrew we should specify range from: 1 to: 2, bounds are included If sending to all three, we will pass range from 1 to 3',
    26: 'used to exclude recipients from the mailing, optional parameter',
    27: 'additional recipients; array of JSON objects',
    28: 'Use macros in messages',
    29: 'You can make your mailing list more personalized by using macros in the message text. These are a set of variables that you can pre-populate for contacts in your databases to substitute a unique value for each recipient. For example, you could populate a customer name for each number in your database and add a named greeting to the message.',
    30: 'Example of how to use the macro:',
    31: "As a result, a message will be sent to 79999999999 with the text: 'Hello Anatoly. I am from Vladikavkaz', and to 71111111111 - 'Hello Antony. I am from New York.'",
    32: 'For the database, you can pre-fill the required contact fields, the value of which will be substituted in the macros.',
    33: 'Custom message for part of the recipients',
    34: 'You can use the optional custom_message element to hard-code the message text for a specific recipient.',
    35: 'This request will send "Greetings!" to the phone number 79123456789 because the custom_message message text is set for this recipient,',
    36: 'will be sent to the phone number 79992223333,',
    37: 'will go to the phone number 79997777777, because no name or custom_message field is set for it.',
    38: 'Getting the status of mailing lists',
    39: 'Filters can be used:',
    40: 'mailing list name',
    41: 'mailing list status',
    42: 'mailing list creation date',
    43: 'method of sending the request, possible values are web, api',
    44: 'For filtering you need to pass JSON with necessary parameters and their values to body.',
    45: 'Example body:',
    46: 'Retrieve sms status',
    47: 'Parameters in this method act as filters, it is not necessary to pass all of them.',
    48: 'Parameter details:',
    49: 'date FROM',
    50: 'date BEFORE',
    51: 'filter by mailing title',
    52: 'filter by mailing ID',
    53: 'filter by number',
    54: 'filter by status. Possible values: ',
    55: 'filter by sender name, the field is named in the response',
    56: 'sort direction',
    57: 'sorting field',
    58: 'General mailing list statistics',
    59: 'Parameters in this method act as filters, it is not necessary to pass all of them.',
    60: 'More about parameters: ',
    61: 'Specify grouping. Possible values: ',
    62: 'required parameter',
    63: 'Filter by sending source. Possible values:',
    64: 'filter by sender name',
    65: 'pagination',
    66: 'sort direction',
    67: 'sort field',
    68: 'Number Verification',
    69: 'Number verification is a convenient feature that allows you to verify that a phone number exists and belongs to the person who provided it. Zorra provides 4 ways of verification: by sms, by the last digits of the incoming number, by the code dictated during the call, by calling the outgoing number.',
    70: 'Verification by sms',
    71: 'An SMS with a unique code will be sent to the number to be verified. Then the user enters the received code, if it matches the sent code - the number is verified.',
    72: 'After this request the number 79123456789 will receive a sms in the format "Code: 123". According to what is specified in the code.',
    73: 'the number to be verified will be sent a sms to it',
    74: 'mandatory parameter',
    75: 'if this parameter is passed, the specified code will be sent in the sms. If the parameter is not specified, we generate the code ourselves, size size (6 characters, unless otherwise specified)',
    76: 'parameter that specifies the length of the code to generate if the code parameter is not specified, if the code is specified manually, it is not necessary to transmit',
    77: 'parameter for easy tracking of results',
    78: 'verification request identifier',
    79: 'verification type',
    80: 'verification number',
    81: "parameter indicating which side the code was set on. In this case the code was passed in the request, so we assume it was generated manually and not on Zorra's side, so true",
    82: 'region',
    83: 'To check the code you can use the method:',
    84: 'Note that the check method only works for cases where the code was generated automatically.',
    85: 'The lifetime of the submitted code is 5 minutes, after that it becomes invalid',
    86: 'The body of the request should contain the phone number to which the code was sent and the code entered by the user in order to check it against the sent code.',
    87: 'An example of a response if the code was sent',
    88: 'Example response if incorrect code is entered:',
    89: 'Verification by the last digits of the number',
    90: "The number to be verified will receive an incoming call from a unique number. Then the user must enter a certain number of last digits of the number from which the call came, if they match the number of the call, the user's number is verified.",
    91: 'After this request, 79123456789 will receive a call from a number ending in 12345 as specified in the code.',
    92: 'the number to be verified will receive a call, mandatory parameter.',
    93: 'if passed this parameter, the call will be from a number ending in the given digits. If no parameter is specified, we generate the digits into the number ourselves, size ',
    94: '(6 characters unless otherwise specified)',
    95: 'parameter specifies how many digits to generate into the number, if parameter',
    96: 'not specified. If the code is manually set, it does not need to be passed.',
    97: 'parameter for easy tracking of results, defaults to "en".',
    98: 'verification request identifier',
    99: 'verification type',
    100: 'verification number',
    101: "parameter indicating which side the code was set on. In this case the code was passed in the request, so we assume it was generated manually and not on Zorra's side, so true",
    102: 'region',
    103: 'You can use the method to check the code:',
    104: 'Note that the check method only works for cases where the code was automatically generated.',
    105: 'The lifetime of the submitted code is 5 minutes, after that it becomes invalid',
    106: 'In the body of the request you need to pass the phone number where the call was sent and the code entered by the user to check against the number that called him.',
    107: 'verifiable number',
    108: 'the code value from the number the user entered',
    109: 'Sample response if the code is correct:',
    110: 'Verification by the code dictated when calling',
    111: "The number you want to check will receive an incoming call from the number you purchased. The owner of the number should pick up the phone and listen to the code that will be dictated to him. Then he has to enter the code he heard and if the correct code is entered, the user's number is verified.",
    112: 'Important: to use this type of verification, you must have at least 1 purchased Zorra number.',
    113: 'Before submitting requests, you must submit at least one purchased phone number for verification. You may use more than one number at a time.',
    114: 'Send request:',
    115: 'Instead of {number_id} - substitute the ID of the phone number you purchased. Calls will be made from it.',
    116: 'Number to be verified, mandatory parameter.',
    117: 'you can pass a specific code to be dictated in the request. If you do not pass this parameter, Zorra will generate the unique size code itself',
    118: 'the parameter specifies the length of the code to be generated (1-6) if the code parameter is not passed (default size = 6).',
    119: "ID of one of the numbers you sent for verification. If you do not pass this parameter, the number will be selected randomly from among all those sent.",
    120: 'specifies the language in which the code will be dictated.',
    121: 'Valid parameter values',
    122: 'Russian language',
    123: 'English language',
    124: 'Spanish language',
    125: 'French language',
    126: 'Italian language',
    127: 'Japanese language',
    128: 'Vietnamese language',
    129: 'Filipino language',
    130: 'Swedish language',
    131: 'Example of a successful response:',
    132: 'verification request identifier',
    133: 'verification type',
    134: 'verification number',
    135: 'parameter indicating which side the code was set on. In this case the code was passed in the request, so we think it was generated manually, so true',
    136: 'indicates what language the code was spoken in',
    137: 'To check the code, you can use the method:',
    138: 'Note that the check method only works for cases where the code was generated automatically',
    139: 'The lifetime of the submitted code is 5 minutes, after that it becomes invalid',
    140: 'The body of the request should contain the phone number to which the call was sent and the code entered by the user to check against the one dictated to him.',
    141: 'Example of a successful response if the codes match:',
    142: 'Databases',
    143: 'Get a list of groups',
    144: 'In Zorra, you can organize your databases into groups for easier collaboration. Use this method to get a list of database groups.',
    145: 'Get a list of databases',
    146: 'You can make a query without parameters, then the result will be all the databases you have on your account.',
    147: 'This query will return all databases in the group with ID 83, sorted by ID.',
    148: 'database group ID',
    149: 'field to sort by',
    150: 'sorting direction (asc, desk)',
    151: 'Create database',
    152: 'VIP clients',
    153: 'Get the list of contacts in the database',
    154: 'Instead of {id} - substitute the ID of the recipient database you want to retrieve.',
    155: 'Note that pagination is applied in the response (<u>meta</u> block in the response). You can paginate by passing the <u>current_page</u> parameter. And also pass the maximum number of elements on the page in the parameter',
    156: '(max 500).',
    157: 'You can use the <u>search</u> parameter to filter results by number, email, name, last_name fields.',
    158: 'Create a contact in the database',
    159: 'Delete recipient',
    160: "Instead of {id} - substitute the contact's database ID, instead of {recipient_id} - its ID.",
    161: 'Change recipient',
    162: "Instead of {id} - substitute the contact's database ID, instead of {recipient_id} - its ID.",
    163: 'Pass in the body of the request the fields to be changed and their new values.',
    164: 'View recipient',
    165: "Instead of {id} - substitute the contact's database ID, and instead of {recipient_id} - its ID.",
    166: 'label_for_recipient',
    167: 'Secondary specialization',
    168: 'HLR requests',
    169: 'HLR query or Home Location Register is used to analyze the phone number status of a particular subscriber. It allows you to weed out inactive numbers from your mailing list databases.',
    170: 'To use HLR queries, you need to analyze the status of a specific phone number in your mailing list',
    171: 'You can also process table files with numbers by uploading them for processing via your personal account, HLR section.',
    172: 'Sending HLR request',
    173: 'You can send in one request an array of numbers to be checked at once.',
    174: 'In the response you will receive the request ID, by which you can further request the results statistics',
    175: 'Retrieving HLR query results',
    176: 'In the response you will get the results of the paginated verification.',
    177: 'Sending a verification request:',
    178: '',
    dasha: 'Daria',
    andrey: 'Andrew',
    misha: 'Michael'
  }
};
